import Image from 'next/image'

import { Text } from '@/shared/components/typography'

const SectionTemplate = ({ name }: { name: string }) => {
  return (
    <div className="flex flex-col items-center gap-6 text-center">
      <Text level="text1" weight="bold" color="text090">
        지금 주차를 시작해 주세요.
      </Text>
      <Text level="text2" color="caution070">
        {`${name} 구간 내 빈자리에 주차헤주세요.`}
        <br />
        {`(바닥표시${name} 또는 ▵-${name}-○)`}
        <br />
        {`※ 전용이라고 적혀있는 자리는 주차 할 수 없습니다.`}
      </Text>
      <Image
        src="/images/share_section.png"
        alt="구간 주차장"
        width={275}
        height={145}
        unoptimized
        className="h-full w-full px-[27px] pt-3"
      />
    </div>
  )
}

export default SectionTemplate
